// Must load before React / React DOM (instrumentation hooks).
import { scan } from 'react-scan';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { ClerkProvider } from '@clerk/clerk-react';
import './index.css';
import App from './App';

scan({
  enabled: process.env.NODE_ENV === 'development',
  showToolbar: true
});

const PUBLISHABLE_KEY = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

if (!PUBLISHABLE_KEY) {
  const errorMessage = process.env.NODE_ENV === 'production'
    ? 'Missing Clerk Publishable Key. Please set REACT_APP_CLERK_PUBLISHABLE_KEY environment variable in Railway (or your deployment platform).'
    : 'Missing Clerk Publishable Key. Please set REACT_APP_CLERK_PUBLISHABLE_KEY in your .env.local file.';
  throw new Error(errorMessage);
}

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <ClerkProvider publishableKey={PUBLISHABLE_KEY} afterSignOutUrl="/">
      <App />
    </ClerkProvider>
  </React.StrictMode>
);